import { InnerSectionAttributes } from './section';
import { LinkSection } from '../types/link';

export type BaseImageAttributes = {
  alt: string;
  src: string;
} & InnerSectionAttributes;

export type BaseImageEditorIds = [
  'alt',
  'src',
];

export type SrcSetImageAttributes = {
  original: string;
  srcset: {
    src: string;
    width: number | 'full';
  }[];
} & BaseImageAttributes;

export type SrcSetImageEditorIds = BaseImageEditorIds;

export type ImageDownloadAttributes = {
  downloadUrls: {
    high: string;
  };
}

export type ImageDownloadEditorIds = [
  'showDownload',
];

export type ImageLinkAttributes = {
  link: LinkSection;
}

export type ImageLinkEditorIds = [];

export type ImageTopicAttributes = {
  topic: string;
}

export type ImageTopicEditorIds = [
  'topic',
];

export type CopyrightImageAttributes = {
  copyright: string;
  copyrightColor: 'black' | 'white';
}

export type CopyrightImageEditorIds = [
  'copyright',
  'copyrightColor',
];

export const IMAGE_COMPONENT_NAME = 'image';
